import { SearchListItem } from './searchList';
import { SuggestedProduct as SuggestedProductModel } from 'models/SuggestedProduct';
import Image from 'components/Shared/Image';
import { BhImageType } from 'models/BhImageType';
import { CardPrice } from 'components/Shared/Price/themes/BGH/cardPrice';
import styles from './styles.scss';
import { rm } from 'utils';

const SUGGESTED_PRODUCT_SIZE = 76;
const PRODUCT_IMAGE_WRAPPER_STYLE: React.CSSProperties = { width: '100%' };

export interface SuggestedProductProps extends SuggestedProductModel {
  reset: () => void;
  hidePicture: boolean;
  executeSearch?: (url: string) => void;
}

export const SuggestedProduct = (props: SuggestedProductProps) => {
  const { displayName, hidePicture } = props;
  const categoryName = displayName.substr(0, displayName.indexOf(' '));
  const productName = displayName.substr(displayName.indexOf(' ') + 1);

  return (
    <SearchListItem {...props} selected={props.selected} className={styles.product}>
      {!hidePicture && (
        <div className={styles.productImageFlexWrapper}>
          <Image
            paddingBottom
            wrapperStyle={PRODUCT_IMAGE_WRAPPER_STYLE}
            className={styles.productImage}
            type={BhImageType.Product}
            id={props.imageGuid}
            name={props.imageName}
            width={SUGGESTED_PRODUCT_SIZE}
            height={SUGGESTED_PRODUCT_SIZE}
          />
        </div>
      )}
      <div className={styles.productInfo}>
        <span className={styles.nameWrapper}>
          <span className={styles.categoryName}>{categoryName}</span>
          <span className={styles.displayName}>{productName}</span>
        </span>
        {!props.hiddenPrice ? (
          <CardPrice
            inCard
            page="search"
            price={{
              hiddenPrice: false,
              listPrice: 0,
              lowestPartPaymentPrice: 0,
              rentalPrice: props.rentalPrice,
              presentationPrice: props.presentationPrice,
              currencyUnit: props.currencyUnit,
              isFromPrice: props.isFromPrice
            }}
          />
        ) : (
          <span className={styles.nonPurchable}>{rm('pl_product_non_purchable')}</span>
        )}
      </div>
    </SearchListItem>
  );
};
